module.exports = __webpack_public_path__ + "img/7.cdfbce5a.png";